/**
* 基础菜单  销售标签管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item> 商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>销售标签管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.label_name" placeholder="标签名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addLabel" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editLabel" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delLabel">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 70%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="label_name" label="标签名称" min-width="200">
        </el-table-column>
        <el-table-column prop="creater_name" label="创建人" width="180">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180">
        </el-table-column>
        <el-table-column prop="expires_time" label="结束时间" width="180">
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="122">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="viewImageForm(scope.row.id)">查看标签</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="labelDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form :model="labelForm" :rules="rules" ref="labelForm" label-width="165px" class="labelForm">
        <el-form-item label="标签名称" prop="label_name" class="relative">
          <el-input v-model="labelForm.label_name" clearable placeholder="请输入标签名称">
          </el-input>
        </el-form-item>
        <el-form-item label="标签图片" prop="detail_label_url" clearable class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-remove="handleRemove"
            :http-request="handleUpload"
            :before-upload="beforeUpload">
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="ax_default">
            <span>图片尺寸500px*500px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</span>
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="expires_time" class="relative">
          <template>
            <div class="block">
              <el-date-picker
                v-model="labelForm.expires_time"
                type="datetime"
                placeholder="请选择结束时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="labelFirm('labelForm')">确 认</el-button>
            <el-button @click="saveSort">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="imageFormVisible"
               width="30%"
               center
               class="frame">
      <el-image
        style="width: 100%; height: 500px;background: #fff;"
        :src="imageData.detail_label_url"
      >
      </el-image>
    </el-dialog>

  </div>
</template>

<script>
import {
  labelList, labelAdd, labelUpdate, labelDelete, labelDetail, labelEnabled, labelDisable,
  shopImage, groupDelete, groupEnabled, flashDetail
} from '../../api/basisMG'
import Pagination from '../../components/Pagination'
import {getToken, upload, uploadImgTmp} from '../../api/commonMG'
import {uploadFile,timestampToTime} from "../../utils/util";

export default {
  data: () => {
    return {
      loading: false, // 显示加载
      labelDialogVisible: false, // 控制页面显示与隐藏
      imageFormVisible: false,
      dialogTitle: '', // 标题
      productId: '',
      selectTableData: [],
      imgUrl: '',
      label_id: '',
      formInline: {
        page: 1,
        rows: 10,
        label_name: '',
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // rules表单验证
      rules: {
        label_name: [{required: true, message: '请输入标签名称', trigger: 'blur'}],
        detail_label_url: [{required: true, message: '请添加标签图片', trigger: 'blur'}],
        expires_time: [{required: true, message: '请选择结束时间', trigger: 'blur'}],
      },
      labelForm: {
        id: '',
        label_name: '',
        label_id: '',
        detail_label_url: '',
        detail_label_id: '',
        expires_time: '',
      },
      form: {
        image: ''
      },
      imageData: {
        id: '',
        detail_label_url: '',
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      labelList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.content.rows
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.rows
            this.pageparm.total = res.content.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.rows = parm.pageSize
      this.getdata(this.formInline)
    },
    // 有效状态
    changeStatus(id, status) {
      if (!status) {
        labelDisable(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'error',
                message: '已将状态设置为无效!'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      } else {
        labelEnabled(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '已将状态设置为有效!'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      }
    },
    // 新增销售标签信息-弹窗
    addLabel() {
      this.labelDialogVisible = true;
      this.dialogTitle = '新增销售标签信息';
      this.form.image = '';
      this.imgUrl = '';
      this.labelForm = {
        id: '',
        label_name: '',
        label_id: '',
        detail_label_url: '',
        detail_label_id: '',
        expires_time: '',
      };
    },
    // 修改销售标签信息-弹窗
    editLabel() {
      if (this.selectTableData.length == 0) {
        this.$message.error('请选择一条数据再操作!');
        return
      }
      if (this.selectTableData.length > 1) {
        this.$message.error('当前操作只能选择一条数据!');
        return
      }
      this.productId = this.selectTableData[0].id;
      this.dialogTitle = '修改销售标签信息';
      this.labelDialogVisible = true;
      this.labelForm.label_name = this.selectTableData[0].label_name;
      this.labelForm.detail_label_url = this.selectTableData[0].detail_label_url;
      this.labelForm.expires_time = this.selectTableData[0].expires_time;
      this.detail(this.selectTableData[0].id);
    },
    detail(id) {
      this.loading = true
      labelDetail(this.selectTableData[0].id)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if(res.content) {
              this.form.image = res.content.detail_label_url;
              this.imgUrl = res.content.detail_label_url;
              this.imageData = res.content;
              this.labelForm = res.content;
              this.$set(this.labelForm,'expires_time',this.selectTableData[0].expires_time);
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 删除销售标签信息-弹窗
    delLabel() {
      if (this.selectTableData.length == 0) {
        this.$message.error('请选择一条数据再操作!');
        return
      }
      if (this.selectTableData.length > 1) {
        this.$message.error('当前操作只能选择一条数据!');
        return
      }
      const title = '是否删除商品销售标签？';
      this.$confirm(title, '删除销售标签', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        labelDelete(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功删除标签!'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 确认按钮
    labelFirm(formName) {
      this.labelForm.detail_label_url = this.imgUrl;
      if (this.labelForm.expires_time) {
        this.labelForm.expires_time = timestampToTime(this.labelForm.expires_time)
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.dialogTitle == '新增销售标签信息') {
            labelAdd(this.labelForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功新增标签'
                  });
                  this.saveSort();
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误,请稍后再试!')
              })
          } else {
            this.labelForm.id = this.productId;
            this.labelForm.label_id = this.productId;
            this.labelForm.detail_label_id = this.productId;
            this.loading = true;
            labelUpdate(this.labelForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功修改标签'
                  });
                  this.saveSort();
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.loading = false;
                this.$message.error('网络错误,请稍后再试!')
              })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 查看标签图片
    viewImageForm: function (id) {
      this.imageFormVisible = true
      this.loading = true
      labelDetail(id)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            if(res.content) {
              this.imageData = res.content;
            }
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 取消按钮
    saveSort() {
      this.labelDialogVisible = false
    },
    handleClose() {
      this.$refs["labelForm"].resetFields();
      this.labelDialogVisible = false;
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata(this.formInline)
    },
    handleSelectionChange(val) {
      this.selectTableData = val
    },
    productSortChange(sort_id, brand_id, type) {
      console.log(file);
    },
    handleRemove(file) {
      console.log(file);
    },
    // 可以获取图片参数
    handleUpload(file) {
      console.log(file)
    },
    // 限制图片尺寸
    limitFileWH(E_width, E_height, file) {
      const _this = this
      let imgWidth = ''
      let imgHight = ''
      const isSize = new Promise(function (resolve, reject) {
        const width = E_width
        const height = E_height
        const _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = function () {
          imgWidth = img.width
          imgHight = img.height
          const valid = img.width === width && img.height === height
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(() => {
        // const fileData = new FormData();
        // fileData.append("image", file);
        // //upload为上传的接口
        // upload(fileData).then(res => {
        //   this.imgUrl = res.attrs.file_url;
        //   //对返回的图片地址进行回显
        //   this.$set(this.form, "image", res.attrs.file_url);
        // });
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
              this.imgUrl =  res.data.content.file.fileUrl;
              //对返回的图片地址进行回显
              this.$set(this.form, "image",  res.data.content.file.fileUrl);
            })
          }
        });
        //阻止传到本地浏览器
        return false;
      }, () => {
        _this.$message.error({
          message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
          btn: false
        })
        return false
      })
      return isSize
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;
      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      //   return;
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
        return;
      }
      // 调用[限制图片尺寸]函数
      this.limitFileWH(500, 500, file)
    },
    //双击复制
    cellDbClick(row, column, cell, event) {
      if (row.label_name == cell.innerText) {
        if (event.type === "dblclick") {
          var save = function (e) {
            e.clipboardData.setData('text/plain', cell.innerText);
            e.preventDefault();//阻止默认行为
          }
          document.addEventListener('copy', save);
          document.execCommand("copy");
          document.removeEventListener('copy', save);
        }
        this.$message({message: '复制成功', type: 'success'})
      }
    }
  }
}
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }


  /deep/ .labelForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .labelForm .el-input {
    width: 320px;
  }

  /deep/ .labelForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  /deep/ .frame .el-dialog {
    box-shadow: none;
    background: none;

  }

  /deep/ .frame .el-icon-close:before {
    content: "";
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatarbig {
    width: 500px;
    height: 500px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  /deep/ .el-form-item__content {
    display: flex;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader {
    height: 122px;
  }

  .ax_default {
    border-width: 0px;
    width: 216px;
    height: 60px;
    display: flex;
    font-size: 11px;
    color: #D9001B;
    text-align: left;
    line-height: 20px;
    margin: 40px 0 0 10px;
  }

  /deep/ .el-descriptions-item__label.has-colon::after {
    content: ''!important;
  }

  /deep/ .block .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 320px;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/GoodLabel.vue